import { registerLazyI18nextInstance } from "@packages/core-client/i18n/registerLazyI18nextInstance.ts";
import type { FireflyRuntime } from "@squide/firefly";

export const i18NextInstanceKey = "home-module";

export function initI18next(runtime: FireflyRuntime) {
    return registerLazyI18nextInstance(runtime, i18NextInstanceKey, {
        "en-US": async () => {
            const [{ en }, { en: individualContributorEn }] = await Promise.all([import("./en.ts"), import("./individual-contributor/en.ts")]);

            return { ...en, ...individualContributorEn };
        },
        "fr-CA": async () => {
            const [{ fr }, { fr: individualContributorFr }] = await Promise.all([import("./fr.ts"), import("./individual-contributor/fr.ts")]);

            return { ...fr, ...individualContributorFr };
        }
    });
}
